import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';

import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { getFunctions, provideFunctions } from '@angular/fire/functions';
import { initializeAppCheck, provideAppCheck } from '@angular/fire/app-check';
import { ReCaptchaV3Provider } from 'firebase/app-check';
// import { getStorage, provideStorage } from '@angular/fire/storage';
import { environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),

    provideFirebaseApp(() => initializeApp(environment.firebase)), 
    provideAuth(() => getAuth()),
    provideFirestore(() => getFirestore()),
    provideFunctions(() => getFunctions(undefined, 'australia-southeast1')), // region is critical for onCall functions
    provideAppCheck(() => {
      // Explicitly disable debug provider to ensure production reCAPTCHA is used
      if (typeof self !== 'undefined' && 'FIREBASE_APPCHECK_DEBUG_TOKEN' in self) {
        delete (self as any).FIREBASE_APPCHECK_DEBUG_TOKEN;
      }
      
      const siteKey = environment.firebase.appCheck?.recaptchaSiteKey;
      if (!siteKey || siteKey.trim() === '') {
        throw new Error('reCAPTCHA site key is required');
      }
      const provider = new ReCaptchaV3Provider(siteKey);
      
      return initializeAppCheck(undefined, { 
        provider, 
        isTokenAutoRefreshEnabled: true 
      });
    })
    //provideStorage(() => getStorage())
  ]
};
